var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/tcomb/lib/Any.js
// module id = 112
// module chunks = 0